import { Form, Row, Col, Button } from "react-bootstrap";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  editModal,
  openModal,
  resetFormState,
  setSelectValidError,
} from "../../../slices/common/reducer";
import { renderElement } from "../../../Components/Common/FormRendererV2/Renderer";
import { OrganizationModalLayoutJSON } from "./Json/OrganizationLayoutJson";
import { createOrganization } from "./OrganizationService";
import { getOrgId, getOrgType } from "../../../Utils/CommonUtils";

const NewOrganizationModal = () => {
  const dispatch = useDispatch();
  const modalShow = useSelector((state) => state.common.modalShow);
  // const edit = useSelector((state) => state.common.editShow);
  const formState = useSelector((state) => state.common.formRendererState);
  const organizationFieldsJson = useSelector(
    (state) => state.organization.organizationFieldsJson
  );
  const selectedUser = useSelector((state) => state.header.selectedUser);
  const parentId = selectedUser.organizationid;
  const organizationType = getOrgType();

  const handleClose = () => {
    dispatch(openModal(false));
    dispatch(editModal(false));
    dispatch(resetFormState());
    // dispatch(setRolesEditID(null));
    dispatch(setSelectValidError(false));
  };

  const addNewClickHandler = (e) => {
    e.preventDefault();
    if (formState.status) {
      dispatch(setSelectValidError(false));
      createOrganization(formState, parentId, organizationType);
    } else {
      dispatch(setSelectValidError(true));
    }
  };

  return (
    <Modal
      isOpen={modalShow}
      onHide={() => handleClose()}
      centered
      className="border-0"
      modalClassName="modal fade zoomIn"
      toggle={handleClose}
    >
      <Form className="tablelist-form" onSubmit={addNewClickHandler}>
        <ModalHeader className="p-3 bg-info-subtle" toggle={handleClose}>
          {"New Organization"}
        </ModalHeader>
        <ModalBody className="modal-body">
          <Row className="g-3">
            <Col lg={12}>
              {OrganizationModalLayoutJSON.map((element) => (
                <div key={element.elementid}>
                  {element.child.map((child) =>
                    renderElement(child, organizationFieldsJson, formState)
                  )}
                </div>
              ))}
            </Col>
            <Col lg={12}>
              <div className="hstack gap-2 justify-content-end">
                {/* <button
                  type="button"
                  className="btn btn-light"
                  onClick={() => handleClose(false)}
                >
                  Close
                </button> */}
                {/* <Button
                  onClick={handleClose}
                  className="primary primary_button"
                  id="addNewMember"
                >
                  {edit ? "Update" : "Cancel"}
                </Button> */}
                <Button
                  type="submit"
                  className="primary primary_button"
                  id="addNewMember"
                >
                  {/* {edit ? "Update" : "Save"} */}
                  Save
                </Button>
              </div>
            </Col>
          </Row>
        </ModalBody>
      </Form>
    </Modal>
  );
};

export default NewOrganizationModal;
